import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ISODate } from 'ha/helpers/hadate/types';
import { APIV2_URL } from './constants';
import { ListingExclusionsResource } from './types/ListingExclusionsResource';

interface Query {
  rangeFrom?: ISODate;
  rangeTo?: ISODate;
}

export default (makeCall: MakeCall) => (
  listingId: string | number,
  { rangeFrom, rangeTo }: Query = {},
) =>
  makeCall<ListingExclusionsResource>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      query: { rangeFrom, rangeTo },
    },
  );
